import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@radix-ui/react-dialog';
import X from "../../../../assets/images/x.png";
import profileSuccess from "../../../../assets/images/profileSuccess.png";

const BadgesSuccessModal = ({ visible, onRequestClose, onPress, message, type }:any) => {
  return (
    <Dialog open={visible} onOpenChange={onRequestClose}>
      <DialogContent className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center rounded-t-[4%]">
        {type === 'profile' ? (
          <div className="bg-white mx-[3%] rounded-[20px] flex flex-col items-center py-[1%] w-[70%] h-[100px]">
            <button
              className="absolute top-[10px] right-[10px]"
              onClick={onRequestClose}
            >
              <img
                src={X}
                alt="Close"
                className="object-contain"
                style={{ height: '20px', width: '20px', filter: 'hue-rotate(0deg) saturate(0%) brightness(0%)' }}
              />
            </button>
            <img
              src={profileSuccess}
              alt="Profile Success"
              className="object-contain mt-[-4.5%]"
              style={{ height: '11%', width: '11%' }}
            />
            <span
              className="text-black text-lg font-bold text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Profile photo updated
            </span>
            <span
              className="text-black text-sm font-medium text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Your profile photo has been updated successfully
            </span>
            <button
              onClick={onPress}
              className="bg-gradient-to-r from-[#363E70] to-[#A458BA] rounded-[20px] px-[5%] py-[1%] my-[1%]"
            >
              <span
                className="text-white text-sm font-bold"
                style={{ fontFamily: "'Lato', sans-serif", lineHeight: '20px' }}
              >
                Done
              </span>
            </button>
          </div>
        ) : (
          <div className="bg-white mx-[3%] rounded-[20px] flex flex-col items-center py-[1%] w-[70%] h-[100px]">
            {/* <div className="bg-[#E9BE50] border-4 border-white rounded-full flex items-center justify-center h-[11%] w-[11%] mt-[-4.5%] shadow-md">
              <img
                src="/assets/messageSquare.png"
                alt="Message"
                className="object-contain"
                style={{ height: '5%', width: '5%' }}
              />
            </div> */}
            <span
              className="text-black text-sm font-medium text-center px-[6%] pb-[1%] mt-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {message}
            </span>
            {/* <button
              onClick={onPress}
              className="bg-gradient-to-r from-[#363E70] to-[#A458BA] rounded-[20px] px-[5%] py-[1%] my-[1%]"
            >
              <span
                className="text-white text-sm font-bold"
                style={{ fontFamily: "'Lato', sans-serif", lineHeight: '20px' }}
              >
                Ok
              </span>
            </button> */}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};


export default BadgesSuccessModal;